/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-restricted-globals */
import { Accordion, SkeletonLoading } from '@saleshandy/design-system';
import {
  Check,
  ChevronDown,
  ChevronUp,
  Filter,
  FilterSearch,
  Lock,
  Minus,
  Plus,
} from '@saleshandy/icons';
import { useOverlayScrollbars } from 'overlayscrollbars-react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import 'overlayscrollbars/styles/overlayscrollbars.css';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { useHistory } from 'react-router';
import Button from '../../../../shared/design-system/components/atoms/button';
import Tag from '../../../../shared/design-system/components/tag';
import { FilterComponentType, LeadFinderSecondaryTab } from '../../types';
import { FILTER_GROUP_ORDER, FILTER_LIST } from '../hooks/useLeadFilter';
import Autocomplete from './search-auto-complete';
import CompanyListFilter from './company-list-filter/company-list-filter';
import DropDownFilterComponent from './v2-dropdown-filter';
import V2FilterCheckbox from './checkbox-filter';
import KeywordInputComponent from './keyword-search-input/keyword-search-input';
import SavedFilter from './saved-filter/saved-filter';
import RadioFilter from './v2-radio-filter';
import RadioButtonGroup from '../../../../shared/design-system/components/radio-button-group';
import { Placement } from '../../../../shared/design-system/components/overlay';
import { accessibleOnClick } from '../../../../shared/utils/accessible-on-click';
import Input from '../../../../shared/design-system/components/input';
import AiSearchFilterAnimation from './ai-search-filter-animation/ai-search-filter-animation';
import { RootState } from '../../../../store/root-reducer';
import { BULK_SEARCH_FILTERS } from './leads-filter-bulk-search/config';
import { RESTRICTED_PEOPLE_FILTER_IDS } from '../../helpers/helper';
import UpgradeFilterModal from './upgrade-filter-modal';
import TruncatedTextWithAutoTooltip from '../../../../shared/components/truncated-text-with-auto-tooltip';

export default function V2LeadFilter({
  handleRecentSearch,
  handleGeneratePayload,
  setSelectedLeads,
  onBulkSearchShow,
  handleDeleteFilter,
  handleGetAllKeysByFilterFromQuery,
  handleIndividualTag,
  handleFoundValueExceptFromList,
  handleQuery,
  bulkFilterSyncKey,
  showPhoneNumberNudge,
  searchLeads,
  isLoading,
  keywordInputRef,
  activeSubTab,
  applyPendingFilters,
  hasPendingFilters,
  clearPendingFilters,
  pendingFilters,
  handleRouteChange,
  onClearAll,
  skipUrlPushForBulkSearch = false,
  peopleListsData = [],
  companyListsData = [],
  isLoadingCompanyLists = false,
  isLoadingPeopleLists = false,
  companyIdNameMap,
  setCompanyIdNameMap,
}) {
  const [selectedFilter, setSelectedFilter] = useState<any>([]);
  const [expandedGroups, setExpandedGroups] = useState<Set<string>>(
    () => new Set(FILTER_GROUP_ORDER),
  );
  const [showFilterSearch, setShowFilterSearch] = useState(false);
  const [filterSearchQuery, setFilterSearchQuery] = useState('');
  const [knownUnknownValues, setKnownUnknownValues] = useState<
    Record<string, number | null>
  >({});
  const overlayRef = useRef(null);
  const filterSearchInputRef = useRef<HTMLInputElement>(null);
  const accordionKey = 3830;
  const aiSeachPopupSubmitted = useSelector(
    (state: RootState) => state?.leadFinderV2?.aiSeachPopupSubmitted,
  );

  const isFilterRestrictionEnabled = useSelector(
    (state: RootState) => state?.home?.leadFinder?.isFilterRestrictionEnabled,
  );

  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);

  const handleGeneratePayloadForSavedFilter = useCallback(() => {
    const urlEmpty = !(location?.search || '').trim();
    if (skipUrlPushForBulkSearch && urlEmpty && pendingFilters.toString()) {
      return handleGeneratePayload(
        new URLSearchParams(pendingFilters.toString()),
      );
    }
    return handleGeneratePayload();
  }, [
    handleGeneratePayload,
    skipUrlPushForBulkSearch,
    location.search,
    pendingFilters,
  ]);

  const [showTagTooltip, setShowTagTooltip] = useState<any>(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const history = useHistory();

  const [initialize] = useOverlayScrollbars({
    options: {
      overflow: {
        x: 'hidden',
      },
      scrollbars: {
        autoHide: 'leave',
        autoHideDelay: 500,
      },
    },
    defer: true,
  });

  const onSelectFilter = (id, filter) => {
    setSelectedFilter((prevSelectedFilter) => {
      const index = prevSelectedFilter.findIndex((filter) => filter.id === id);
      if (index === -1) {
        return [
          ...prevSelectedFilter,
          {
            id,
            filter,
          },
        ];
      }
      return prevSelectedFilter.filter((filter) => filter.id !== id);
    });
  };

  const onToggleGroup = (groupName: string) => {
    setExpandedGroups((prev) => {
      const next = new Set(prev);
      if (next.has(groupName)) {
        next.delete(groupName);
      } else {
        next.add(groupName);
      }
      return next;
    });
  };

  const isSelectedFilter = useMemo(() => {
    return (filter) => selectedFilter.some((f) => f.id === filter.id);
  }, [selectedFilter]);

  // Group filters by their group property
  const groupedFilters = useMemo(() => {
    const groups: Record<string, any[]> = {};

    // Exclude People List filter when in Net New sub-tab for People
    const effectiveFilterList = FILTER_LIST.filter(
      (filter: any) =>
        !(
          filter?.id === 'filter-people-list' &&
          activeSubTab === LeadFinderSecondaryTab.NEW
        ),
    );

    effectiveFilterList.forEach((filter: any) => {
      const groupName = filter.group || 'Other';
      if (!groups[groupName]) {
        groups[groupName] = [];
      }
      groups[groupName].push(filter);
    });

    // Return groups in the specified order
    return FILTER_GROUP_ORDER.filter(
      (groupName) => groups[groupName] && groups[groupName].length > 0,
    ).map((groupName) => ({
      name: groupName,
      filters: groups[groupName],
    }));
  }, [activeSubTab]);

  const filteredGroupedFilters = useMemo(() => {
    const query = filterSearchQuery.trim().toLowerCase();
    if (!query) return groupedFilters;

    return groupedFilters
      .map((group) => {
        const groupMatches = group.name.toLowerCase().includes(query);
        const matchingFilters = group.filters.filter(
          (f: any) =>
            groupMatches || (f?.label && f.label.toLowerCase().includes(query)),
        );
        return { ...group, filters: matchingFilters };
      })
      .filter((group) => group.filters.length > 0);
  }, [groupedFilters, filterSearchQuery]);

  const appliedGroupCount = useMemo(() => {
    return groupedFilters.reduce((total: number, group: any) => {
      const groupTotal = group.filters.reduce((sum: number, filter: any) => {
        const appliedCount = handleGetAllKeysByFilterFromQuery(filter).size;
        return sum + (appliedCount > 0 ? 1 : 0);
      }, 0);
      return total + groupTotal;
    }, 0);
  }, [
    groupedFilters,
    pendingFilters,
    location?.search,
    handleGetAllKeysByFilterFromQuery,
  ]);

  const handleClearAll = () => {
    // Save current search to recent searches BEFORE clearing
    // This ensures the latest search with filters is saved
    handleRecentSearch();

    // Clear pending filters immediately
    if (clearPendingFilters) {
      clearPendingFilters();
    }

    // Clear URL params (needed for both URL-based and bulk-search-only filters)
    handleRouteChange();
    history.push({ search: '' });

    // Clear local state
    setSelectedFilter([]);
    setSelectedLeads([]);

    onClearAll?.();
  };

  useEffect(() => {
    if (skipUrlPushForBulkSearch && location?.search) {
      const params = new URLSearchParams(location.search);
      if (params.has('company_ids')) {
        return;
      }
      history.replace({ search: '' });
    }
  }, [skipUrlPushForBulkSearch, location?.search]);

  useEffect(() => {
    initialize(overlayRef.current);
  }, [initialize]);

  useEffect(() => {
    if (showFilterSearch && filterSearchInputRef.current) {
      filterSearchInputRef.current.focus();
    }
  }, [showFilterSearch]);

  useEffect(() => {
    if (keywordInputRef.current) {
      keywordInputRef.current.focus();
    }
    return () => {
      setSelectedFilter([]);
    };
  }, []);

  // Sync knownUnknownValues from URL params
  useEffect(() => {
    const newValues: Record<string, number | null> = {};
    FILTER_LIST.forEach((filter) => {
      filter?.type?.forEach((subFilter) => {
        if (subFilter?.advanceFilters?.showKnownUnknownRadio) {
          const isUnknownParam = queryParams.get(`${subFilter.key}_isUnknown`);
          if (isUnknownParam === '1') {
            newValues[subFilter.key] = 1;
          } else if (isUnknownParam === '0') {
            newValues[subFilter.key] = 0;
          } else {
            newValues[subFilter.key] = null;
          }
        }
      });
    });
    setKnownUnknownValues(newValues);
  }, [location?.search]);

  const getLebelTooltip = (text: string) => (
    <Tooltip id="popover-basic" className="bs-tooltip-inner">
      {text}
    </Tooltip>
  );

  const renderFilterAppliedTags = (allTags: Set<any>) => {
    const tagsArray = Array.from(allTags) as any[];
    const includeTags = tagsArray.filter(
      (tag: any) => !tag?.isFlag && !tag?.isExclude,
    );
    const excludeTags = tagsArray.filter(
      (tag: any) => !tag?.isFlag && tag?.isExclude,
    );
    const exactMatchTags = tagsArray.filter(
      (tag: any) => tag?.isFlag && tag?.flagType === 'exactMatch',
    );
    const pastSearchTags = tagsArray.filter(
      (tag: any) => tag?.isFlag && tag?.flagType === 'shouldSearchPast',
    );
    const unknownKnownTags = tagsArray.filter(
      (tag: any) => tag?.isFlag && tag?.flagType === 'isUnknown',
    );
    const renderTagChip = (tag: any, index: number, className: string) => {
      if (tag?.isLoading) {
        return (
          <SkeletonLoading className="filter-tag" width={100} height={20} />
        );
      }
      const displayLabel = tag?.label;
      const truncatedLabel =
        displayLabel?.length > 15
          ? `${displayLabel.substring(0, 15)}..`
          : displayLabel;
      return (
        <span
          key={`${tag?.key}-${tag?.label}`}
          onMouseEnter={() =>
            setShowTagTooltip(`tag-${tag?.key}-${tag?.label || ''}-${index}`)
          }
          onMouseLeave={() => setShowTagTooltip(null)}
        >
          <OverlayTrigger
            placement={Placement.BottomStart}
            overlay={getLebelTooltip(displayLabel)}
            show={
              showTagTooltip ===
                `tag-${tag?.key}-${tag?.label || ''}-${index}` &&
              displayLabel?.length > 15
            }
          >
            <Tag
              value={truncatedLabel}
              variant={Tag.Variant.Remove}
              className={className}
              onClick={(e) => {
                e?.stopPropagation();
                handleIndividualTag(tag);
              }}
            />
          </OverlayTrigger>
        </span>
      );
    };
    return (
      <>
        {includeTags.length > 0 && (
          <div className="filter-section filter-section-includes">
            <span className="filter-section-label">Include</span>
            <div className="filter-section-chips">
              {includeTags
                .slice(0, 3)
                .map((tag, idx) =>
                  renderTagChip(tag, idx, 'filter-tag filter-tag-include'),
                )}
              {includeTags.length > 3 && (
                <Tag
                  value={`+${includeTags.length - 3}`}
                  className="filter-tag more-tag"
                />
              )}
            </div>
          </div>
        )}
        {excludeTags.length > 0 && (
          <div className="filter-section filter-section-excludes">
            <span className="filter-section-label">Exclude</span>
            <div className="filter-section-chips">
              {excludeTags
                .slice(0, 3)
                .map((tag, idx) =>
                  renderTagChip(tag, idx, 'filter-tag filter-tag-exclude'),
                )}
              {excludeTags.length > 3 && (
                <Tag
                  value={`+${excludeTags.length - 3}`}
                  className="filter-tag more-tag"
                />
              )}
            </div>
          </div>
        )}
        {(exactMatchTags.length > 0 ||
          pastSearchTags.length > 0 ||
          unknownKnownTags.length > 0) && (
          <div className="filter-section filter-section-advance">
            <span className="filter-section-label">Advance Filter</span>
            <div className="filter-section-chips">
              {exactMatchTags.map((tag: any) =>
                renderTagChip(tag, 0, 'filter-tag filter-tag-flag'),
              )}
              {pastSearchTags.map((tag: any) =>
                renderTagChip(tag, 0, 'filter-tag filter-tag-flag'),
              )}
              {unknownKnownTags.map((tag: any) =>
                renderTagChip(tag, 0, 'filter-tag filter-tag-flag'),
              )}
            </div>
          </div>
        )}
      </>
    );
  };

  const renderFilterPanelContent = (filter: any) => {
    const isFilterLocked =
      isFilterRestrictionEnabled === 1 &&
      RESTRICTED_PEOPLE_FILTER_IDS.has(filter?.id);
    if (isFilterLocked) return null;
    return (
      <>
        {filter?.type?.map((subFilter) => (
          <React.Fragment key={`subfilter-${filter?.id}-${subFilter.id}`}>
            {subFilter?.value === FilterComponentType.COMPANY_LIST && (
              <CompanyListFilter
                includeKey={subFilter?.key}
                excludeKey={
                  subFilter?.excludeKey ||
                  (subFilter?.key === 'people_list'
                    ? 'excludePeople_list'
                    : 'excludeCompany_list')
                }
                pendingFilters={pendingFilters}
                handleQuery={handleQuery}
                savedListsData={
                  subFilter?.key === 'people_list'
                    ? peopleListsData
                    : companyListsData
                }
                maxTotalLimit={subFilter?.maxTotalLimit}
                isLoadingLists={
                  subFilter?.key === 'people_list'
                    ? isLoadingPeopleLists
                    : isLoadingCompanyLists
                }
              />
            )}
            {subFilter?.value === FilterComponentType.SEARCH_INPUT && (
              <Autocomplete
                isExpand={isSelectedFilter(filter)}
                suggestions={[]}
                filterKey={subFilter?.key}
                placeholder={`Enter ${subFilter?.placeholder}`}
                name={subFilter?.name}
                className={subFilter?.className}
                handleFoundValueExceptFromList={handleFoundValueExceptFromList}
                handleQuery={handleQuery}
                applyPendingFilters={applyPendingFilters}
                advanceFilters={subFilter?.advanceFilters}
                pendingFilters={pendingFilters}
              />
            )}
            {subFilter?.key === 'company_name' &&
              (() => {
                const rawVal = pendingFilters.get('company_name');
                const val =
                  rawVal !== null ? String(rawVal).replace(/"/g, '') : '';
                if (val.trim().length > 50) {
                  return (
                    <div
                      className="error-message mt-1"
                      style={{ fontSize: '12px', color: '#b91c1c' }}
                    >
                      Company name must not be greater 50 characters.
                    </div>
                  );
                }
                return null;
              })()}
            {subFilter?.value === FilterComponentType.MULTILEVEL_CHECKBOX && (
              <>
                <V2FilterCheckbox
                  key={`filter-subfilter-${filter?.id}-${subFilter.id}`}
                  subFilter={subFilter}
                  searchLeads={searchLeads}
                  hideIncludeExclude={
                    subFilter?.hideIncludeExclude ||
                    knownUnknownValues[subFilter.key] === 1
                  }
                  handleQuery={handleQuery}
                  isExpand={isSelectedFilter(filter)}
                  parentKey={filter?.key}
                  bulkFilterSyncKey={bulkFilterSyncKey}
                  handleExpandFilterTags={() => {
                    if (
                      BULK_SEARCH_FILTERS?.map((e) => e.key).includes(
                        subFilter?.key,
                      )
                    ) {
                      onBulkSearchShow(
                        subFilter?.bulkSearchKey || subFilter?.key,
                      );
                    }
                  }}
                  isPhoneNumberNudgeOpen={showPhoneNumberNudge}
                  pendingFilters={pendingFilters}
                  applyPendingFilters={applyPendingFilters}
                  isDisabledByUnknown={knownUnknownValues[subFilter.key] === 1}
                  companyIdNameMap={companyIdNameMap}
                  setCompanyIdNameMap={setCompanyIdNameMap}
                  onLockedClick={() => setShowUpgradeModal(true)}
                />
                {subFilter?.enableBulkSearch && (
                  <Button
                    variant={'link' as any}
                    className="mt-2 mb-0 p-0 blue-txt-11 regular-1"
                    onClick={() =>
                      onBulkSearchShow(
                        subFilter?.bulkSearchKey || subFilter?.key,
                      )
                    }
                  >
                    + Bulk Search
                  </Button>
                )}
              </>
            )}
            {subFilter?.value === FilterComponentType.DROP_DOWN && (
              <DropDownFilterComponent
                subFilter={subFilter}
                handleQuery={handleQuery}
                isDisabledByUnknown={knownUnknownValues[subFilter.key] === 1}
                pendingFilters={pendingFilters}
                applyPendingFilters={applyPendingFilters}
                onLockedClick={() => setShowUpgradeModal(true)}
              />
            )}
            {subFilter?.value === FilterComponentType.RADIO_BUTTON && (
              <RadioFilter
                filterKey={subFilter?.key}
                name={subFilter?.name}
                handleQuery={handleQuery}
                hideLabel={subFilter?.hideLabel}
                className={subFilter?.className}
                pendingFilters={pendingFilters}
              />
            )}
            {subFilter?.advanceFilters?.showKnownUnknownRadio && (
              <Accordion.Item
                uuid={`${subFilter.key}_advance_settings`}
                className="advance-settings-accordion"
              >
                <Accordion.ItemHeading>
                  <Accordion.ItemButton className="::before:none w-100">
                    <div className="w-100 accordian-label">
                      <span>Advance Filter</span>
                      <div className="d-flex align-items-center justify-content-end">
                        <Accordion.ItemState>
                          {({ expanded }) =>
                            expanded ? (
                              <ChevronUp
                                color="#6B7280"
                                className="accordion-minus-icon"
                              />
                            ) : (
                              <ChevronDown
                                color="#6B7280"
                                className="accordion-plus-icon"
                              />
                            )
                          }
                        </Accordion.ItemState>
                      </div>
                    </div>
                  </Accordion.ItemButton>
                </Accordion.ItemHeading>
                <Accordion.ItemPanel>
                  <div className="known-unknown-filter">
                    <RadioButtonGroup
                      name={`${subFilter.key}_known_unknown`}
                      options={[
                        { label: 'Is Known', value: 0 },
                        { label: 'Is Unknown', value: 1 },
                      ]}
                      value={knownUnknownValues[subFilter.key] ?? null}
                      variant={RadioButtonGroup.Variant.Default}
                      onChange={(value) => {
                        const newValue =
                          value === knownUnknownValues[subFilter.key]
                            ? null
                            : value;
                        setKnownUnknownValues((prev) => ({
                          ...prev,
                          [subFilter.key]: newValue,
                        }));

                        let hasFilterValue = false;
                        let currentFilterValue: any = null;

                        if (subFilter.value === FilterComponentType.DROP_DOWN) {
                          currentFilterValue = queryParams.get(subFilter.key);
                          hasFilterValue = !!currentFilterValue;
                        } else if (
                          subFilter.value ===
                          FilterComponentType.MULTILEVEL_CHECKBOX
                        ) {
                          const allValues = queryParams.getAll(subFilter.key);
                          hasFilterValue = allValues.length > 0;
                          if (hasFilterValue) {
                            currentFilterValue = {
                              includedKeys: allValues.map((v) =>
                                v.replace(/"/g, ''),
                              ),
                            };
                          }
                        }

                        if (
                          (hasFilterValue && currentFilterValue) ||
                          newValue !== null
                        ) {
                          handleQuery({
                            filterKey: `${subFilter.key}_isUnknown`,
                            filterValue: newValue,
                            filterType: FilterComponentType.RADIO_BUTTON,
                            showKnownUnknown: newValue,
                            isSearchLeads: true,
                          });
                        } else if (newValue === null) {
                          handleQuery({
                            filterKey: `${subFilter.key}_isUnknown`,
                            filterValue: null,
                            filterType: FilterComponentType.RADIO_BUTTON,
                            showKnownUnknown: null,
                            isSearchLeads: true,
                          });
                        }
                      }}
                    />
                  </div>
                </Accordion.ItemPanel>
              </Accordion.Item>
            )}
          </React.Fragment>
        ))}
      </>
    );
  };

  useEffect(() => {
    if (showPhoneNumberNudge) {
      const contactMethodFilter = FILTER_LIST.find(
        (filter) => filter.id === 'filter-contact-method',
      );
      if (!isSelectedFilter(contactMethodFilter)) {
        setSelectedFilter([
          ...selectedFilter,
          { id: contactMethodFilter.id, filter: contactMethodFilter },
        ]);
      }

      // Find the contact method filter element and scroll it into view
      setTimeout(() => {
        const filterElement = document.querySelector(
          '[data-filter-id="filter-contact-method"]',
        ) as HTMLElement;
        if (filterElement) {
          // Scroll the element into view with smooth behavior
          filterElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest',
          });
        }
      }, 300);
    }
  }, [showPhoneNumberNudge, selectedFilter, isSelectedFilter]);

  return (
    <div className="v2-lead-filter-root v2-people-filter">
      <div className="v2-lead-filter-header">
        <div className="v2-leads-search">
          <KeywordInputComponent
            activeSubTab={activeSubTab}
            handleQuery={handleQuery}
            keywordInputRef={keywordInputRef}
            hideAISearch={false}
            applyPendingFilters={applyPendingFilters}
          />
        </div>
        <h3 className="v2-leads-filter">
          <div className="d-flex align-items-center gap-8">
            <div>
              <Filter className="sh-filter" />
              Filters
            </div>
            {appliedGroupCount > 0 && (
              <span className="v2-leads-filter-count">{appliedGroupCount}</span>
            )}
          </div>
          <div className="v2-leads-filter-actions">
            {(location?.search || hasPendingFilters?.()) && (
              <>
                <Button
                  variant={'link' as any}
                  onClick={handleClearAll}
                  className="clear-all-button"
                >
                  Clear All
                </Button>
                <div className="divider" />
              </>
            )}

            {activeSubTab !== LeadFinderSecondaryTab.SAVED && (
              <div
                className="v2-leads-filter-search-icon"
                {...accessibleOnClick(() => {
                  setShowFilterSearch((prev) => {
                    if (prev) setFilterSearchQuery('');
                    return !prev;
                  });
                })}
              >
                <FilterSearch width={16} height={16} />
              </div>
            )}
          </div>
        </h3>
      </div>

      {showFilterSearch && activeSubTab !== LeadFinderSecondaryTab.SAVED && (
        <div className="v2-leads-filter-search-bar">
          <Input
            placeholder="Search filter name"
            value={filterSearchQuery}
            onChange={setFilterSearchQuery}
            icons={[
              {
                place: Input.IconPlace.Left,
                identifier: 'search',
              },
            ]}
            className="v2-leads-filter-search-input"
            ref={filterSearchInputRef}
          />
        </div>
      )}

      <div className="v2-lead-filters-accordion-container">
        {isLoading &&
        activeSubTab !== LeadFinderSecondaryTab.SAVED &&
        aiSeachPopupSubmitted ? (
          <AiSearchFilterAnimation />
        ) : (
          <div
            key={accordionKey}
            ref={overlayRef}
            className="v2-lead-filters-accordion"
          >
            <Accordion
              className="shd-accordion"
              allowMultipleExpanded
              key={accordionKey}
              allowZeroExpanded
            >
              {filteredGroupedFilters.map((group) => {
                const groupSelectedCount = group.filters.reduce(
                  (sum: number, filter: any) =>
                    sum + handleGetAllKeysByFilterFromQuery(filter).size,
                  0,
                );

                return (
                  <Accordion.Item
                    key={group.name}
                    uuid={`filter-group-${group.name.replace(/\s+/g, '-')}`}
                    dangerouslySetExpanded={expandedGroups.has(group.name)}
                    className={classNames('filter-group-accordion', {
                      'filter-group-collapsed': !expandedGroups.has(group.name),
                    })}
                  >
                    <Accordion.ItemHeading
                      onClick={() => onToggleGroup(group.name)}
                    >
                      <Accordion.ItemButton className="::before:none w-100">
                        <div className="filter-group-header w-100">
                          <span className="filter-group-title">
                            {group.name}
                            {groupSelectedCount > 0 ? (
                              <span className="filter-group-count">
                                {' '}
                                ({groupSelectedCount})
                              </span>
                            ) : null}
                          </span>
                          <div className="d-flex align-items-center">
                            <Accordion.ItemState>
                              {({ expanded }) =>
                                expanded ? (
                                  <ChevronUp
                                    color="#6B7280"
                                    className="accordion-chevron-icon"
                                  />
                                ) : (
                                  <ChevronDown
                                    color="#6B7280"
                                    className="accordion-chevron-icon"
                                  />
                                )
                              }
                            </Accordion.ItemState>
                          </div>
                        </div>
                      </Accordion.ItemButton>
                    </Accordion.ItemHeading>
                    <Accordion.ItemPanel>
                      {expandedGroups.has(group.name) &&
                        group.filters.map((filter: any, index: number) => {
                          const allTags = handleGetAllKeysByFilterFromQuery(
                            filter,
                          );
                          const isFirstInGroup = index === 0;
                          const isFilterLocked =
                            isFilterRestrictionEnabled === 1 &&
                            RESTRICTED_PEOPLE_FILTER_IDS.has(filter?.id);

                          return (
                            <Accordion.Item
                              key={filter?.id}
                              uuid={filter?.id}
                              data-filter-id={filter?.id}
                              dangerouslySetExpanded={
                                !isFilterLocked &&
                                selectedFilter?.some(
                                  (f) => f?.id === filter?.id,
                                )
                              }
                              className={classNames([
                                'accordion__item',
                                {
                                  'first-in-group': isFirstInGroup,
                                },
                                {
                                  accordion__item_selected:
                                    !isFilterLocked && isSelectedFilter(filter),
                                },
                                {
                                  accordion__item_highlighted:
                                    filter?.id === 'filter-contact-method' &&
                                    isSelectedFilter(filter) &&
                                    showPhoneNumberNudge,
                                },
                                {
                                  accordion__item_locked: isFilterLocked,
                                },
                              ])}
                            >
                              <Accordion.ItemHeading
                                onClick={() => {
                                  if (isFilterLocked) {
                                    setShowUpgradeModal(true);
                                  } else {
                                    onSelectFilter(filter.id, filter);
                                  }
                                }}
                                className={`${
                                  allTags.size > 0 && !isSelectedFilter(filter)
                                    ? 'accordion-item-heading-tag'
                                    : 'accordion-item-heading'
                                } ${
                                  allTags.size
                                    ? 'accordion-item-selected-tag'
                                    : ''
                                } ${
                                  isFilterLocked
                                    ? 'accordion-item-heading-locked'
                                    : ''
                                }`}
                              >
                                <Accordion.ItemButton className="::before:none w-100">
                                  <div className="w-100 accordian-label">
                                    <div className="icon">{filter.icon}</div>
                                    <div
                                      className="label"
                                      key={`${filter?.id}-${allTags.size}`}
                                    >
                                      <TruncatedTextWithAutoTooltip
                                        text={filter?.label}
                                      />
                                    </div>
                                    <div className="d-flex align-items-center accordian-label-end">
                                      {!isFilterLocked && allTags.size > 0 && (
                                        <Tag
                                          value={allTags.size}
                                          variant={Tag.Variant.Remove}
                                          className="bg-white rounded-pill"
                                          onClick={(e) => {
                                            e?.stopPropagation();
                                            const shouldApplyFilters =
                                              !!location?.search ||
                                              skipUrlPushForBulkSearch;
                                            const shouldClearAll = handleDeleteFilter(
                                              filter,
                                              shouldApplyFilters,
                                            );
                                            if (
                                              shouldApplyFilters &&
                                              shouldClearAll
                                            ) {
                                              handleClearAll();
                                            }
                                          }}
                                        />
                                      )}
                                      {isFilterLocked ? (
                                        <div
                                          onClick={(e) => {
                                            // prevent accordion toggle
                                            e.stopPropagation();
                                            setShowUpgradeModal(true);
                                          }}
                                          role="button"
                                          tabIndex={0}
                                          onKeyPress={(e) => {
                                            e.stopPropagation();
                                            if (
                                              e.key === 'Enter' ||
                                              e.key === ' '
                                            ) {
                                              setShowUpgradeModal(true);
                                            }
                                          }}
                                        >
                                          <Lock
                                            width={16}
                                            height={16}
                                            color="#F59E0B"
                                            className="accordion-lock-icon"
                                          />
                                        </div>
                                      ) : (
                                        <Accordion.ItemState>
                                          {({ expanded }) =>
                                            expanded ? (
                                              <Minus className="accordion-minus-icon" />
                                            ) : (
                                              <Plus className="accordion-plus-icon" />
                                            )
                                          }
                                        </Accordion.ItemState>
                                      )}
                                    </div>
                                  </div>
                                  {!isFilterLocked &&
                                    allTags.size > 0 &&
                                    !isSelectedFilter(filter) && (
                                      <div className="filter-applied-collapse">
                                        {renderFilterAppliedTags(allTags)}
                                      </div>
                                    )}
                                </Accordion.ItemButton>
                              </Accordion.ItemHeading>

                              <Accordion.ItemPanel>
                                <Accordion.ItemState>
                                  {({ expanded: isFilterExpanded }) =>
                                    isFilterExpanded
                                      ? renderFilterPanelContent(filter)
                                      : null
                                  }
                                </Accordion.ItemState>
                              </Accordion.ItemPanel>
                            </Accordion.Item>
                          );
                        })}
                    </Accordion.ItemPanel>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </div>
        )}
      </div>
      <UpgradeFilterModal
        show={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
      />
      <div className="v2-lead-filter-footer">
        <SavedFilter
          {...{
            handleGeneratePayload: handleGeneratePayloadForSavedFilter,
            isLoading,
            applyPendingFilters,
            hasPendingFilters,
          }}
        />
      </div>
    </div>
  );
}
